import { Layout } from 'antd';

const PrivateLayoutFooter = () => (
  <Layout.Footer
    style={{
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
    }}
  >
    <div>Webcentric ©2019</div>
  </Layout.Footer>
);

export default PrivateLayoutFooter;
